export default __webpack_public_path__ + "static/media/Background_00035.7d827d0a.png";